import styled from 'styled-components';

export const SearchableSelectContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const SearchableSelectInput = styled.input`
  width: 100%;
  padding: 8px 12px;
  font-size: 13px;
  border: 1px solid ${({ theme }) => theme.colors.gray300};
  border-radius: ${({ theme }) => theme.borderRadius.md};
  background: white;
  color: ${({ theme }) => theme.colors.gray900};

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.primary};
    box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.primary}22;
  }
`;

export const SearchableSelectDropdown = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid ${({ theme }) => theme.colors.gray200};
  border-top: none;
  border-radius: 0 0 ${({ theme }) => theme.borderRadius.md} ${({ theme }) => theme.borderRadius.md};
  max-height: 250px;
  overflow-y: auto;
  z-index: 10;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
`;

export const SearchableSelectOption = styled.div<{ $selected: boolean }>`
  padding: 8px 12px;
  font-size: 13px;
  cursor: pointer;
  background: ${({ $selected }) => ($selected ? '#f0f9ff' : 'white')};
  color: ${({ $selected, theme }) => ($selected ? theme.colors.primary : theme.colors.gray900)};
  border-left: 3px solid ${({ $selected, theme }) => ($selected ? theme.colors.primary : 'transparent')};

  &:hover {
    background: #f8fafc;
  }
`;
